<div class="card-publicacao" [class.segundo-tom-fundo]="segundoTomDeFundo">
  <h5 class="titulo-dados-jornal">
    Data: {{dadosJornal?.dataPublicacao | date: 'dd/MM/yyyy'}} | Caderno: {{dadosJornal?.tipoCaderno}}
    @if (dadosJornal?.tipoVisualizacaoMateria === tipoVisualizacaoMateria.PDF) {
      <span> | Página: {{dadosJornal?.pagina}}</span>
    }
  </h5>
  <div>
    <p #textoHighlight class="trecho-pesquisado">... {{dadosJornal?.textoResultado}} ...</p>
  </div>
  <div class="conjunto-botoes">
    <span tabindex="0" (click)="MapeamentoDadosPublicacaoJornal()" (keyup.enter)="MapeamentoDadosPublicacaoJornal()" >
      <svg width="24px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM19 20V4H5V20H19ZM7 6H11V10H7V6ZM7 12H17V14H7V12ZM7 16H17V18H7V16ZM13 7H17V9H13V7Z"></path></svg>
      Visualizar publicação
    </span>

    <span tabindex="0" (click)="obtemDadosJornal()" (keyup.enter)="obtemDadosJornal()">
      <svg width="24px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M4 19H20V12H22V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V12H4V19ZM14 9H19L12 16L5 9H10V3H14V9Z"></path></svg>
      Baixar publicação
    </span>
  </div>
</div>
